export default __webpack_public_path__ + "static/a-series-actuator-dba29cb7e8dbaca25b2c694d942764ae.webp";